<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">货品管理</el-breadcrumb-item>
        <el-breadcrumb-item>出库管理</el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-form :model="querys" ref="querys" label-width="90px" class="search-form">
      <el-row>
        <el-form-item label="关键词" prop="keyword">
          <el-col style="width: 180px">
            <el-input v-model="querys.keyword" @keyup.enter="fetchs" prefix-icon="Search"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item v-if="showOrgFilters" label="所属公司">
          <el-col>
            <!-- <el-cascader v-model="companyId" :options="companys" clearable @change="fetchs" /> -->
            <el-tree-select ref="companys" v-model="companyId" :data="companys" @change="fetchs();"
              check-strictly :render-after-expand="false" style="width:210px" />
          </el-col>
        </el-form-item>

        <el-form-item label="相关渠道">
          <el-col>
            <el-select v-model="channel" placeholder="渠道" clearable @change="fetchs()" style="width: 140px">
              <el-option v-for="item in dict.channels" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="单据时间">
          <el-col>
            <el-date-picker v-model="dateRange" type="daterange" start-placeholder="开始时间" end-placeholder="结束时间"
              unlink-panels :shortcuts="$util.getShortCuts()" @change="fetchs()" style="max-width:210px;">
            </el-date-picker>
          </el-col>
        </el-form-item>

      </el-row>
      <el-row>
        <el-form-item label="操作类型" prop="bizType">
          <el-col>
            <el-select v-model="bizType" placeholder="操作类型" clearable disabled @change="dict.billTypes = []; fetchs()"
              style="width: 180px">
              <el-option key="outbound" label="所有出库" value="outbound"></el-option>
              <el-option key="inbound" label="所有入库" value="inbound"></el-option>
              <el-option key="other" label="其他单据" value="other"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="业务类型" prop="billType">
          <el-col>
            <el-select v-model="billType" placeholder="请选择业务类型" clearable :disabled="!!$route.params.billType"
              @change="fetchs" style="width: 180px">
              <el-option v-for="item in dict.billTypes" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="" label-width="90px">
          <el-button type="primary" icon="Search" @click="fetchs()">
            搜索
          </el-button>
        </el-form-item>
      </el-row>
    </el-form>

    <div class="toolbar">
      <el-button plain type="primary" v-if="isNormal" icon="Minus" @click="$router.push({ path: 'outstore' })">
        操作出库
      </el-button>
      <!-- <el-button type="primary" v-if="isNormal" icon="Sort" @click="transferDialogVisible = true">
        渠道货品调拨
      </el-button> -->
      <el-button plain type="success" v-if="isTransfer" icon="Refresh" @click="realerDialogVisible = true">
        库位调拨
      </el-button>
      <el-button plain type="warning" v-if="isTransfer" icon="Sort" @click="$router.push({ path: '/stock/bills/crossTransfer' })">
        跨公司调拨
      </el-button>
      <el-button plain type="success" v-if="isBorrow" icon="Sort" @click="$router.push({ path: 'borrowDetail' })">
        借出申请
      </el-button>
      <el-button plain type="primary" v-if="isBorrow" icon="Download" @click="exportBorrow">
        导出借出明细
      </el-button>

      <el-button plain icon="Download" @click="exportXls" style="float: right;">
        导出单据
      </el-button>

    </div>
    <!-- 入库弹窗组件 -->
    <div class="xlsdialog">
      <el-dialog title="产品入库" v-model="inDialogVisible" :show-close="true" :close-on-click-modal="false"
        destroy-on-close top="5vh" @closed="inDialogWidth('50%')" :width="dialogWidth" center>
        <instore @In-Dialog-width="inDialogWidth"></instore>
      </el-dialog>
    </div>



    <!-- 渠道调拨弹窗组件 -->
    <div class="xlsdialog">
      <el-dialog title="渠道库存调拨" v-model="transferDialogVisible" :show-close="true" :close-on-click-modal="false"
        destroy-on-close top="5vh" @closed="transferDialogVisible = false" width="80%" center>
        <transfer @dialog-event="dialogEvent"></transfer>
      </el-dialog>
    </div>

    <!-- 公司内库存调拨（旧） -->
    <div class="xlsdialog">
      <el-dialog title="公司内库存调拨（旧）" v-model="realerDialogVisible" :show-close="true" :close-on-click-modal="false"
        destroy-on-close top="5vh" @closed="realerDialogVisible = false" width="80%" center>
        <realer @dialog-event="dialogEvent"></realer>
      </el-dialog>
    </div>

    <basic-table class="table" :query="querys" @handler="tableHandler" :currHandler="currHandler" :seleHandler="seleHandler">

      <template v-slot:status="scope">
        <el-text v-if="scope.row.status == -1" type="danger" size="small" disabled>已取消</el-text>
        <el-text v-if="scope.row.status == 0" type="primary" size="small" disabled>待审核</el-text>
        <el-text v-if="scope.row.status == 11" type="primary" size="small" disabled>待供应链审核</el-text>
        <el-text v-if="scope.row.status == 1" type="success" size="small" disabled>已审核</el-text>
        <el-text v-if="scope.row.status == 2" type="info" size="small" disabled>已归还</el-text>
      </template>

      <template v-slot:completionDate="scope">
        <el-text size="small" v-if="scope.row.completionDate">
          <span v-if="isBorrow">预计归还:</span>
          <span v-else>完成时间:</span>
          {{ $util.fmtDate(scope.row.completionDate, 'yyyy-MM-dd') }}
        </el-text>
      </template>

      <template v-slot:toolbar="scope">
        <el-button @click="watch(scope.row)" type="primary" text size="small">
          [查看]
        </el-button>
      </template>
    </basic-table>
  </el-card>
</template>

<script>
import { h } from 'vue';
import { fetchBills, exportBill } from "@/api/stock";
import StaticDialog from "@/components/static-dialog.vue";
import BasicTable from "@/components/basic-table.vue";
import instore from "@/views/stock/bills/instore.vue";
import transfer from "@/views/stock/bills/transfer.vue";
import realer from "@/views/stock/bills/realer.vue";
export default {
  name: "billIndex",
  components: { StaticDialog, BasicTable, instore, transfer, realer },
  data() {
    return {
      dateRange: [],

      querys: {
        keyword: "",
        filters: [],
        columns: [
          { type: "selection", width: "55" },
          { type: "index", label: "序号" },
          { prop: "billType", label: "单据类型", sortable: true, searchable: true, width: "120", showOverflowTooltip: true, },
          { prop: "billCode", label: "单据编号", sortable: true, searchable: true, width: "130", showOverflowTooltip: true, },
          { prop: "storeCode", label: "库房", sortable: true, searchable: true, width: "110", showOverflowTooltip: true, },
          { prop: "channelCode", label: "渠道", sortable: true, searchable: true, width: "110", showOverflowTooltip: true, },
          { prop: "netCode", label: "关联单号", sortable: true, searchable: true, width: "110", showOverflowTooltip: true, },
          { prop: "productNumber", label: "数量", sortable: true, searchable: true, width: "70", },
          { prop: "costTotal", label: "金额", sortable: true, width: "90", },
          { prop: "goldWeightTotal", label: "金重", sortable: true, width: "90", },
          { prop: "billDate", label: "单据时间", width: "140", sortable: true, showOverflowTooltip: true, },
          { type: "template", prop: "status", label: "状态", width: "100", searchable: true, align: "center" },
          { type: "template", prop: "completionDate", label: "完成时间", width: "140", sortable: true, showOverflowTooltip: true, },
          { prop: "operatorName", label: "操作", searchable: true, width: "80", showOverflowTooltip: true, },
          { prop: "handoverName", label: "交接/审核", searchable: true, width: "80", showOverflowTooltip: true, },
          { prop: "reviewerName", label: "复核/出库", searchable: true, width: "80", showOverflowTooltip: true, },
          { prop: "financerName", label: "财务", searchable: true, width: "80", showOverflowTooltip: true, },
          { prop: "remark", label: "备注", sortable: true, searchable: true, width: "130", showOverflowTooltip: true },

          { prop: "createDate", label: "创建时间", width: "150", sortable: true, showOverflowTooltip: true },
          { prop: "createUserName", label: "创建人", sortable: true, searchable: true, width: "100", },
          { type: "toolbar", label: "操作", width: "150" },
        ],

        sidx: "billDate",

        sord: "descending",
      },
      selects: [],
      currRow: null,
      inDialogVisible: false,
      transferDialogVisible: false,
      realerDialogVisible: false,
      dialogWidth: "50%",

      companys: [],
      companyId: '',
      channel: '',

      bizType: 'outbound',
      billType: '',
      dict: {
        billTypes: [],
        outboundTypes: [],
        inboundTypes: [],
        channels: []
      },
    };
  },
  mounted() {
  },
  methods: {
    watch(row) {
      if (this.isBorrow)
        this.$router.push({ path: "borrowDetail", query: { billCode: row.billCode } });
      else if ((row.billType || '').indexOf('跨公司调拨') > -1) {
        const currentBillCode = (row.netCode || row.billCode || '').trim();
        this.$router.push({ path: "/stock/bills/crossTransfer", query: { billCode: currentBillCode } });
      }
      else
        this.$router.push({ path: "detail", query: { billCode: row.billCode } });
    },

    fetchs() {
      this.querys.filters = [];

      if (this.dateRange && this.dateRange[0])
        this.querys.filters.push({
          name: "billDate",
          value: this.$util.fmtDate(this.dateRange[0], "yyyy-MM-dd"),
          operate: 2,
        });
      if (this.dateRange && this.dateRange[1])
        this.querys.filters.push({
          name: "billDate",
          value: this.$util.fmtDate(this.dateRange[1], "yyyy-MM-dd") + " 23:59:59",
          operate: 4,
        });

      if (this.showOrgFilters) {
        if (!this.companyId || this.companyId.length == 0)
          this.companyId = this.$store.getters.getUserInfo?.companyID || '';
        this.querys.filters.push({ name: "companyId", value: (this.companyId || ''), operate: 6, });
      }

      if (this.channel) {
        this.querys.filters.push({ name: "channelCode", value: '%' + this.channel + '%', operate: 5, });
      }

      let billTypes = [];
      this.dict.billTypes.forEach((res) => { billTypes.push(res.value) });

      if (this.billType && this.billType.length > 0) {
        this.querys.filters.push({ name: "billType", value: '%' + this.billType + '%', operate: 5, });
      } else {
        // this.querys.filters.push({
        //   name: "billType",
        //   value: billTypes.join(','),
        //   operate: 6,
        // });

        if (this.bizType == 'outbound') {
          this.querys.filters.push({ name: "productNumber", value: '0', operate: 3, });
          this.billTypes = this.dict.outboundTypes.map(item => item.value);
        }
        else if (this.bizType == 'inbound') {
          this.querys.filters.push({ name: "productNumber", value: '0', operate: 1, });
          this.billTypes = this.dict.inboundTypes.map(item => item.value);
        }
        else if (this.bizType == 'other') {
          this.querys.filters.push({ name: "productNumber", value: '0', operate: 0, });
        }
      }


      //移除多余的参数
      //let { data, records, total, ...query } = { ...params };
      let { data, records, total, ...search } = {
        ...this.querys,
      };

      fetchBills(search).then((res) => {
        this.querys = { ...res.data };
      });
    },
    tableHandler(query) {
      this.querys = { ...this.querys, ...query };
      this.fetchs();
    },
    currHandler(row) {
      this.currRow = row;
    },
    pageHandler(page) {
      this.querys.page = page;
      this.fetchs();
    },
    sizeHandler(rows) {
      this.querys.rows = rows;
      this.fetchs();
    },
    sortHandler(order) {
      this.querys.sidx = order.prop;
      this.querys.sord = order.order;
      this.fetchs();
    },
    seleHandler(rows) {
      this.selects = rows;
    },
    //控制dialog宽度与子组件控制关闭弹窗
    inDialogWidth(data) {
      if (data === "80%" || data === "50%") {
        this.dialogWidth = data;
      } else {
        this.inDialogVisible = false;
        this.fetchs();
      }
    },
    dialogEvent(data) {
      if (data === 'realerDialogVisible') {
        this.realerDialogVisible = false;
      } else if (data === 'transferDialogVisible') {
        this.transferDialogVisible = false;
      }
      this.fetchs();
    },
    exportXls() {
      if (this.selects.length == 0) {
        this.$message({ message: '请勾选至少一个订单' });
        return;
      }
      this.selects.forEach(element => {
        exportBill(element.billCode).then((res) => {
          if (res.code == 200)
            window.location = process.env.VUE_APP_BASEURL + res.data;
        });
      });
      // if (this.currRow) {
      //   exportBill(this.currRow.billCode).then((res) => {
      //     if (res.code == 200)
      //       window.open(process.env.VUE_APP_BASEURL + res.data);
      //   });
      // }
    },
    exportBorrow() {
      // 使用 Vue 的 h 函数来创建虚拟 DOM 节点
      const selectOptions = [
        { value: '', label: '所有借货明细' },
        { value: 'borrowed', label: '借出且未归还明细（已出库等待归还）' },
        { value: 'returned', label: '借出已全部归还明细（已出库全部归还）' },
        { value: 'partial', label: '借出已部分归还明细（已出库部分归还）' },
      ];
      let selectValue = selectOptions[0].value;

      this.$alert(h('div', {}, [
        h('select', {
          style: 'width: 280px',
          onChange: (event) => {
            console.log('Selected:', event.target.value);
            selectValue = event.target.value;
          }
        }, selectOptions.map(option =>
          h('option', { value: option.value }, option.label)
        )),
      ]), {
        title: '请选择要导出货品明细数据的类型',
        dangerouslyUseHTMLString: true,
        showCancelButton: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then((action) => {
        if (action == 'confirm') {
          console.log(selectValue);

          // 构建接口参数
          let params = {
            PreType: '借货',
            CompanyID: this.companyId || '',
            Channel: this.channel || '',
            BillType: '',
            StockStatus: selectValue,
            StartDate: this.dateRange && this.dateRange[0] ? this.$util.fmtDate(this.dateRange[0], "yyyy-MM-dd") : null,
            EndDate: this.dateRange && this.dateRange[1] ? this.$util.fmtDate(this.dateRange[1], "yyyy-MM-dd") : null
          };

          this.$kaung.fetch({
            url: '/StockBound/ExportWithBill',
            method: 'post',
            params: params,
          }).then((res) => {
            this.$notify({
              title: "导出成功",
              message: res.content,
              type: "success",
              duration: 10000
            });
            window.location.href = process.env.VUE_APP_BASEURL + res.data;
          }).catch((error) => {
            this.$message.error(error.message || '导出失败');
          });
        }
      });
    }
  },
  watch: {
    // 监听路由参数变化
    '$route': {
      handler(to, from) {
        // 页面刷新和路由变化都会触发
        this.billType = to.params.billType || to.query.billType || this.$util.getPageCache('billType') || "";

        this.$kaung.dictionary("stock", "outbound").then((res) => {
          this.dict.billTypes = res;
          this.dict.outboundTypes = res;

          this.fetchs();
        });
      },
      immediate: true  // ✅ 立即执行一次，处理页面刷新情况
    },
    companyId: function (newValue, oldValue) {
      console.log('watch companyId', newValue);
      if (newValue && newValue != oldValue)
        this.$util.setLocalstorage('companyIdStr', newValue);
      else
        this.$util.setLocalstorage('companyIdStr', '');
    },
    // billType: function (newValue, oldValue) {
    //   //状态改变时保存（如果页面有参数传递进来不要缓存）
    //   if (newValue != oldValue && this.$route.meta.billType == null && this.$route.params.billType == null)
    //     this.$util.setPageCache('billType', newValue);
    // },
    status: function (newValue, oldValue) {
      if (newValue != oldValue)
        this.$util.setPageCache('status', newValue);
    },
    pager: function (newValue, oldValue) {
      this.$util.setPageCache('keyword', newValue.keyword);
      if (newValue.page)
        this.$util.setPageCache('page', newValue.page);
      if (newValue.rows)
        this.$util.setPageCache('rows', newValue.rows);
      if (newValue.sidx)
        this.$util.setPageCache('sidx', newValue.sidx);
      if (newValue.sord)
        this.$util.setPageCache('sord', newValue.sord);
    },
    dateRange: function (newValue, oldValue) {
      console.log(newValue);
      if (newValue && newValue != oldValue)
        this.$util.setLocalstorage('dateRangeStr', newValue.join(','));
      else
        this.$util.setLocalstorage('dateRangeStr', ',');
    },
  },
  created: function () {
    if (this.showOrgFilters) {
      this.$kaung.companys().then((res) => {
        this.companys = res;
      });
      let companyIdStr = this.$util.getLocalstorage('companyIdStr');
      if (companyIdStr && companyIdStr.length > 0) {
        this.companyId = companyIdStr;
      }
    } else {
      this.companyId = '*';
    }

    this.$kaung.dictionary("stock", "channel").then(res => this.dict.channels = res);

    // this.billType = this.$route.query.billType || this.$util.getPageCache('billType') || "";
    if (this.$route.params.billType) {
      this.billType = this.$route.params.billType;
    }

    this.$kaung.dictionary("stock", "outbound").then((res) => {
      this.dict.billTypes = res;
      this.dict.outboundTypes = res;
    });

    this.$kaung.dictionary("stock", "inbound").then((res) => {
      this.dict.inboundTypes = res;
    });

    this.status = this.$util.getPageCache('status');

    this.querys.keyword = this.$util.getPageCache('keyword');

    this.querys.page = parseInt(this.$util.getPageCache('page') || 1);
    this.querys.rows = parseInt(this.$util.getPageCache('rows') || 10);

    let sidx = this.$util.getPageCache('sidx');
    if (sidx) this.querys.sidx = sidx;
    let sord = this.$util.getPageCache('sord');
    if (sord) this.querys.sord = sord;

    let dateRangeStr = this.$util.getLocalstorage('dateRangeStr');
    if (dateRangeStr != '' && dateRangeStr.split(',').length == 2) {
      this.dateRange = dateRangeStr.split(',');
    }

  },
  computed: {
    isNormal() { return !this.$route.params.billType; },
    isBorrow() { return this.$route.params.billType && (this.$route.params.billType || '').indexOf('借货') > -1; },
    isTransfer() { return this.$route.params.billType && (this.$route.params.billType || '').indexOf('调拨') > -1; },
  },
};
</script>

<style lang="less">
.xlsdialog {
  .el-dialog__body {
    max-height: 80vh;
    overflow-y: auto;
  }
}

.el-form .el-date-editor {
  width: 220px;
}
</style>>







